import React, { Component } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { Box } from '@piconetworks/ui'
import Form from '@piconetworks/pkg-form'
import style from './Pagination.module.scss'
import ScreenSizeContext from 'utils/contexts/ScreenSize/context'
import PageSelector from './PageSelector'

class Pagination extends Component {
    constructor(props) {
        super()
        this.changePage = this.changePage.bind(this)
        this.changePageRowCount = this.changePageRowCount.bind(this)

        this.state = {
            visiblePages: this.getVisiblePages(null, props.pages),
            pageSize: {
                value: props.pageSize,
                label: `${props.pageSize} per page`
            }
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.pages !== nextProps.pages) {
            this.setState({
                visiblePages: this.getVisiblePages(nextProps.page, nextProps.pages),
                pageSize: {
                    value: nextProps.pageSize,
                    label: `${nextProps.pageSize} per page`
                }
            })
            this.changePage(nextProps.page + 1)
        }
    }

    filterPages = (visiblePages, totalPages) => {
        return visiblePages.filter((page) => page <= totalPages)
    }

    getVisiblePages = (page, total) => {
        if (total < 7) {
            return this.filterPages([1, 2, 3, 4, 5, 6], total)
        } else {
            if (page % 5 >= 0 && page > 4 && page + 2 < total) {
                return [1, page - 2, page - 1, page, page + 1, page + 2, total]
            } else if (page % 5 >= 0 && page > 4 && page + 2 >= total) {
                return [1, total - 4, total - 3, total - 2, total - 1, total]
            } else {
                return [1, 2, 3, 4, 5, total]
            }
        }
    }

    changePage(page) {
        const activePage = this.props.page + 1

        if (page === activePage) {
            return
        }

        const visiblePages = this.getVisiblePages(page, this.props.pages)

        this.setState({
            visiblePages: this.filterPages(visiblePages, this.props.pages)
        })

        this.props.onPageChange(page - 1)
    }

    changePageRowCount(data) {
        this.setState({ pageSize: data }, () => this.props.onPageSizeChange(data))
    }

    render() {
        const { data, page, pages, dontShowOptions = false, dontShowRowCount = false } = this.props
        const { visiblePages, pageSize } = this.state

        return (
            <ScreenSizeContext.Consumer>
                {({ isMdUp }) => (
                    <Box.Flexbox.Container justifyContent="between" alignItems="center" className={cx(style.footer)}>
                        {!dontShowRowCount && <Box.Flexbox.Child className={cx(style.child, style.count)}>
                            {data.count}
                        </Box.Flexbox.Child>}
                        {isMdUp ? (
                            <PageSelector.Desktop
                                flexFill={dontShowOptions && dontShowRowCount}
                                page={page}
                                pages={pages}
                                visiblePages={visiblePages}
                                changePage={(e) => this.changePage(e)}
                            />
                        ) : (
                            <PageSelector.Mobile
                                page={page}
                                pages={pages}
                                visiblePages={visiblePages}
                                changePage={(e) => this.changePage(e)}
                            />

                        )}
                        {!dontShowOptions && <Box.Flexbox.Child className={cx(style.child, style.dropdown, style.perPage)}>
                            <Form.Dropdown
                                name="record_per_page"
                                options={[
                                    { value: 10, label: '10 per page' },
                                    { value: 25, label: '25 per page' },
                                    { value: 50, label: '50 per page' },
                                    { value: 100, label: '100 per page' }
                                ]}
                                menuPlacement="top"
                                input={{
                                    onChange: this.changePageRowCount,
                                    onBlur: (e) => console.log(e),
                                    value: pageSize.value
                                }}
                                meta={{
                                    error: null
                                }}
                            />
                        </Box.Flexbox.Child>}
                    </Box.Flexbox.Container>

                )}
            </ScreenSizeContext.Consumer>)

    }
}

Pagination.propTypes = {
    data: PropTypes.object.isRequired,
    dontShowOptions: PropTypes.bool,
    dontShowRowCount: PropTypes.bool,
    onPageChange: PropTypes.func.isRequired,
    onPageSizeChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    PageButtonComponent: PropTypes.any,
    pages: PropTypes.number,
    pageSize: PropTypes.number.isRequired,
}

export default Pagination
